export default __webpack_public_path__ + "static/imgAlloy-16eb2640e1b75a99df065439d9d0224f.webp";